import * as React from 'react'

type OpenIndice = {
  isOpen: (index: string) => boolean
  updateOpenIndices: (index: string) => void
}

export function useIndice(): OpenIndice {
  const [openIndices, setOpenIndices] = React.useState<Array<string>>([])

  const isOpen = (index: string): boolean => {
    return openIndices.findIndex(element => element === index) !== -1
  }

  const updateOpenIndices = (index: string): void => {
    const activeIndex = openIndices.findIndex(element => element === index)
    const updatedOpenIndices = [...openIndices]

    if (activeIndex >= 0) {
      updatedOpenIndices.splice(activeIndex, 1)
    } else {
      updatedOpenIndices.push(index)
    }

    setOpenIndices(updatedOpenIndices)
  }

  return {
    isOpen: (index: string) => isOpen(index),
    updateOpenIndices: (index: string) => updateOpenIndices(index),
  }
}
